import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import { ArtificialIntelligenceApi } from 'Api/ArtificialIntelligence/ArtificialIntelligenceApi';
import { ControlsApi } from 'Api/Controls/ControlsApi';
import { Alert } from 'Components/Alert/Alert';
import { Button } from 'Components/Buttons/Buttons';
import { Modal } from 'Components/Modal/Modal';
import { SaveControlGroupFormFields, SaveControlGroupFromFieldsProps, useSaveControlGroup } from 'Components/OperationalControls/SaveControlGroup/SaveControlGroup';
import { ICON_CLOSE } from 'Config/Icons';

export interface CreateControlGroupModalProps {
    artificialIntelligenceApi: ArtificialIntelligenceApi;
    hideModal: () => void;
    onControlGroupCreated: () => void;
    controlsApi: ControlsApi;
    controlFramework: string;
}

export const CreateControlGroupModal = (props: CreateControlGroupModalProps) => {
    const [successMessage, setSuccessMessage] = useState<string>();
    const [failureMessage, setFailureMessage] = useState<string>();
    const { saveControlGroupStatus, saveControlGroupFormFieldsValues, error, saveControlGroup, handleChange } = useSaveControlGroup(props.controlFramework, props.controlsApi, {
        customControlGroupName: '',
        customControlGroupDescription: '',
    });

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        await saveControlGroup();
    };

    const { onControlGroupCreated } = props;

    useEffect(() => {
        switch (saveControlGroupStatus) {
            case 'saved':
                setSuccessMessage('Control group created.');
                onControlGroupCreated();
                break;
            case 'error':
                setFailureMessage(error?.message);
                break;
            default:
                setSuccessMessage(undefined);
                setFailureMessage(undefined);
        }
    }, [error, onControlGroupCreated, saveControlGroupStatus]);

    const saveControlGroupFormFieldsProps: SaveControlGroupFromFieldsProps = {
        artificialIntelligenceApi: props.artificialIntelligenceApi,
        saveControlGroupFormFieldsValues: saveControlGroupFormFieldsValues,
        handleChange: handleChange,
        disabled: saveControlGroupStatus === 'saved',
    };

    return (
        <Modal open header="Create Custom Control Group">
            {successMessage && <Alert type="success">{successMessage}</Alert>}
            {failureMessage && error && <Alert type="error">{failureMessage}</Alert>}
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <SaveControlGroupFormFields {...saveControlGroupFormFieldsProps} />
                <div className={'modalFormButtonContainer'}>
                    <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                        Close
                    </Button>
                    <Button variant="submit" disabled={saveControlGroupStatus === 'saved'} isLoading={saveControlGroupStatus === 'saving'} loadingText="Saving...">
                        CREATE
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};
